module.exports = __webpack_public_path__ + "static/person-1.9f15fd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicare/person-1.png
// module id = 236
// module chunks = 129662963943619 142354426033121